module.exports = __webpack_public_path__ + "img/H3.ba93ead3.png";